import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty',
  templateUrl: './app-empty.component.html',
  styleUrls: ['./app-empty.component.css']
})
export class AppEmptyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
